import type { SWRConfiguration } from 'swr'
import useSWR from 'swr'
import { COMMENT_API_PREFIX } from 'shared/api/constants/api-constants'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { LikeInterface } from './types'

export const getLastLikesKey = (commentId: number): string =>
  `${COMMENT_API_PREFIX}/${commentId}/last_likes`

export const useCommentLikes = ({
  commentId,
  enabled = true,
  config,
}: {
  commentId: number
  enabled?: boolean
  config?: SWRConfiguration<LikeInterface[], Error>
}) => {
  const { fetcher } = useApiWrapperWithErrorValidation<RequestMethodsEnum.get, LikeInterface[]>({
    method: RequestMethodsEnum.get,
  })

  return useSWR<LikeInterface[], Error>(
    enabled ? getLastLikesKey(commentId) : null,
    fetcher,
    config,
  )
}
